module.exports = __webpack_public_path__ + "static/img/illus-landing.60b7bf7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illus-landing.webp
// module id = 110
// module chunks = 0